// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1hoAp","col":"styles_col__1iO2U"};